import { createApp } from 'vue'
import App from './components/HelloWorld.vue'
// Importa o CSS comum
import './assets/css/common.css';

//Importa o tema minimal
import './assets/css/themes/theme-minimal.css';

import 'intl-tel-input/build/css/intlTelInput.css'
import './assets/css/intl-tel-fix.css'


createApp(App).mount('#app')
